
import {Component, Vue} from 'vue-property-decorator';
import {dispatchGetFormValuesByID, dispatchGetMenuForm, dispatchUpdateFormsValues} from '@/store/main/actions';
import {readFormValues, readMenuForm} from '@/store/main/getters';
import {IFormValues} from '@/interfaces/form';
import {commitAddNotification} from '@/store/main/mutations';
import AlertDialogWrapper from '@/components/dialogs/AlertDialogWrapper.vue';
import AlertDialogFrame from '@/components/dialogs/AlertDialogFrame.vue';
import SearchEngineDialog from '@/components/dialogs/SearchEngineDialog.vue';

@Component({
  components: {
    SearchEngineDialogWrapper: SearchEngineDialog, AlertDialogWrapper, AlertDialogFrame,
  },
})
export default class EditFormValues extends Vue {
  private alertDialog: any = null;
  private alertHeader: string = '';
  private alertMessage: string = '';

  private formSearchEngineDialog: any = null;

  private localFormValues: IFormValues = {} as IFormValues;
  private formValueID: number = 0;
  private formID: number = 0;
  private isLoading: boolean = true;
  private showFallback: boolean = false;
  private fallbackTimer: number = 0;


  public async mounted() {
    this.formValueID = this.$router.currentRoute.params.id as unknown as number;
    await this.loadMountSettings();
  }

  public async beforeRouteUpdate(to, from, next) {
    this.formValueID = this.$router.currentRoute.params.id as unknown as number;
    await this.loadMountSettings();
    next();
  }

  private get shouldRender() {
    return this.menuForm && this.formID && !!this.localFormValues?.form_values;
  }

  private get formValues() {
    return readFormValues(this.$store)(+this.formValueID);
  }

  private get menuForm() {
    return readMenuForm(this.$store)(+this.formID);
  }


  private async loadMountSettings() {
    this.isLoading = true;
    this.showFallback = false;
    this.formID = 0;
    this.localFormValues = {} as IFormValues;
    if (this.fallbackTimer) {
      clearTimeout(this.fallbackTimer);
    }
    this.fallbackTimer = setTimeout(() => {
      if (!this.shouldRender) {
        this.isLoading = false;
        this.showFallback = true;
      }
    }, 30000);

    await dispatchGetFormValuesByID(this.$store, this.formValueID);
    if (!this.formValues) {
      return;
    }

    this.$set(this, 'localFormValues', JSON.parse(JSON.stringify(this.formValues)));
    this.formID = this.formValues?.form_id as unknown as number;
    if (this.formID && !this.menuForm) {
      await dispatchGetMenuForm(this.$store, this.formID);
    }
    this.formSearchEngineDialog = await this.$refs.search_engine_dialog;

    // Inicia as instancias do alert para salvar os dados alterados

    this.alertDialog = this.$refs.alert_dialog;
    this.alertHeader = `Deseja registrar o formulário?`;
    this.alertMessage = `Atenção! antes de salvar, verifique cuidadosamente se todas as informações foram registradas corretamente.`;

    // @ts-ignore
    this.$form.validationErrorAlertText = this.$t('errors.invalid_form');
    // this.$form.valueContainer = this.$t('errors.invalid_form');
    // @ts-ignore
    this.$formEvent.$off('renderer.validation_ok');
    // @ts-ignore
    this.$formEvent.$once('renderer.validation_ok', this.commitAfterFormValidation);
    clearTimeout(this.fallbackTimer);
    this.isLoading = false;
    this.showFallback = !this.shouldRender;

    // if (!this.localFormValues.form_values[0]) {
    //     commitAddNotification(this.$store, {
    //       content: 'Se seu formulário não foi carregado, por favor, atualize a página.',
    //       color: 'warning',
    //     });
    // }
  }

  private async runFormValidation() {
    if (!this.localFormValues || !this.localFormValues.form_values) {
      commitAddNotification(this.$store,
          {content: 'O formulário não está preenchido! Informe ao menos um valor para continuar...', color: 'warning'});
      // @ts-ignore
      this.$formEvent.$once('renderer.validation_ok', this.commitAfterFormValidation);
      return;
    }
    // @ts-ignore
    this.$formEvent.$emit('renderer.run_validation', true);
  }

  private async cancel() {
    await this.$router.push({name: 'main-forms-list', params: {id: `${this.formID}`}});
  }

  private async commitAfterFormValidation() {
    const resp = await this.alertDialog.open().then((result) => {
      return result;
    });
    if (!resp) {
      // @ts-ignore
      this.$formEvent.$once('renderer.validation_ok', this.commitAfterFormValidation);
      return;
    }
    // @ts-ignore
    if (this.localFormValues?.id > 0) {
      const formUpdated = await dispatchUpdateFormsValues(this.$store, this.localFormValues);
      if (!!formUpdated) {
        await this.$router.push({name: 'main-forms-list', params: {id: `${this.formID}`}});
      } else {
        // @ts-ignore
        this.$formEvent.$once('renderer.validation_ok', this.commitAfterFormValidation);
      }
    } else {
      commitAddNotification(this.$store,
          {
            content: 'Não foi possível atualizar o formulário! <br>' +
                'Tente novamente ou contate o suporte técnico', color: 'warning',
          });
    }
  }

}
